import z from 'zod'

export const GetSourceSchema = z.object({
  alias: z.string(),
  domain: z.string().nullish(),
  title: z.string(),
})
